import { AppBar, BottomNavigation, BottomNavigationAction, Box, Card, CardContent, CardHeader, Container, createMuiTheme, makeStyles, SvgIcon, Theme, Typography } from "@material-ui/core";
import { blue, grey, pink } from "@material-ui/core/colors";
import React, { useState } from "react";
import * as Tone from "tone";
import BarcodeDialog from '../../shared/BarcodeDialog';
import BarcodeKeyboard from '../../shared/BarcodeKeyboard';
import usePaletteType from "../../shared/Hooks/usePaletteType";

const useStyles = makeStyles((theme: Theme) => ({
  layoutRoot: {
    marginTop: theme.spacing(2),
  },
  root: {
    paddingTop: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  bottomNavigation: {
    top: "auto",
    bottom: theme.spacing(1),
    boxShadow: "inherit"
  }
}));

let prevBarcode = "";

export default function Component()
{
  const classes = useStyles();

  const paletteType = usePaletteType();

  const palettes = {
    primary: {
      dark: {
        contrastText: grey[300],
        main: '#35363a',
      },
      light: {
        contrastText: 'white',
        main: blue[500],
      },
    },
    secondary: {
      dark: { main: blue[500] },
      light: { main: pink[200] },
    },
    text: {
      primary: {
        dark: grey[300],
        light: '#000',
      },
    },
  }

  const theme = createMuiTheme({
    palette: {
      primary: palettes.primary[paletteType],
      secondary: palettes.secondary[paletteType],
      text: {
        primary: palettes.text.primary[paletteType],
      },
      type: paletteType,
    },
    typography: {
    },
  });

  const [data, setData] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Box className={classes.layoutRoot}>
      <Container maxWidth="xs">
        <Card>
          <CardHeader title="Demo!" subheader="Vonalkód beolvasás!" />
          <CardContent>
            <Typography variant="body2" component="p">Kattints az alább található gombra:</Typography>
          </CardContent>
        </Card>
      </Container>
      <BarcodeKeyboard enabled={true} onBarcodeUpdate={(barcode) =>
      {
        const osc = new Tone.Oscillator(880, "square").toDestination();
        osc.onstop = s =>
        {
          Tone.Transport.stop();
          setData(barcode);
        };
        osc.sync().start(0).stop(0.05);
        Tone.Transport.start();
      }
      } />
      <BarcodeDialog dialogOpen={dialogOpen} onBarcodeUpdate={(err, result) =>
      {
        if(result)
        {
          const barcode = result.getText();
          if(barcode !== prevBarcode)
          {
            prevBarcode = barcode;
            const osc = new Tone.Oscillator(880, "square").toDestination();
            osc.onstop = s =>
            {
              Tone.Transport.stop();
              setData(barcode);
              setDialogOpen(false);
            };
            osc.sync().start(0).stop(0.05);
            Tone.Transport.start();
          }
        }
      }} onCancel={() => { setDialogOpen(false) }} />
      <Container maxWidth="xs" style={{ paddingTop: theme.spacing(1) }}>
        {data ? <Typography>A beolvasott vonalkód: <b>{data}</b></Typography> : <></>}
      </Container>
      <AppBar position="fixed" color="transparent" className={classes.bottomNavigation}>
        <Container maxWidth="sm">
          <BottomNavigation showLabels>
            <BottomNavigationAction label="Vonalkód" icon={<SvgIcon>
              <path stroke="null" id="svg_3" d="m1.046054,4.697369c0,-0.576125 0.467108,-1.043233 1.043233,-1.043233l2.608082,0l0,-1.043233l-2.608082,0c-1.152251,0 -2.086466,0.934215 -2.086466,2.086466l0,2.608082l1.043233,0l0,-2.608082zm0,14.605261l0,-2.608082l-1.043233,0l0,2.608082c0,1.152251 0.934215,2.086466 2.086466,2.086466l2.608082,0l0,-1.043233l-2.608082,0c-0.576125,0 -1.043233,-0.467108 -1.043233,-1.043233zm21.907892,0c0,0.576125 -0.467108,1.043233 -1.043233,1.043233l-2.608082,0l0,1.043233l2.608082,0c1.152251,0 2.086466,-0.934215 2.086466,-2.086466l0,-2.608082l-1.043233,0l0,2.608082zm-1.043233,-16.691727l-2.608082,0l0,1.043233l2.608082,0c0.576125,0 1.043233,0.467108 1.043233,1.043233l0,2.608082l1.043233,0l0,-2.608082c0,-1.152251 -0.934215,-2.086466 -2.086466,-2.086466zm-20.864659,9.389096c0,0.287932 0.233684,0.521616 0.521616,0.521616l20.864659,0c0.287932,0 0.521616,-0.233684 0.521616,-0.521616s-0.233684,-0.521616 -0.521616,-0.521616l-20.864659,0c-0.287932,0 -0.521616,0.233684 -0.521616,0.521616zm8.345864,-6.259398l-1.043233,0l0,4.694548l1.043233,0l0,-4.694548zm-6.259398,0l0,4.694548l1.043233,0l0,-4.694548l-1.043233,0zm8.345864,0l-1.043233,0l0,4.694548l1.043233,0l0,-4.694548zm5.216165,0l-1.043233,0l0,4.694548l1.043233,0l0,-4.694548zm2.086466,0l-1.043233,0l0,4.694548l1.043233,0l0,-4.694548zm1.043233,0l0,4.694548l1.043233,0l0,-4.694548l-1.043233,0zm-12.518795,0l-2.086466,0l0,4.694548l2.086466,0l0,-4.694548zm7.302631,0l-2.086466,0l0,4.694548l2.086466,0l0,-4.694548zm-6.259398,12.518795l1.043233,0l0,-4.694548l-1.043233,0l0,4.694548zm-4.172932,0l0,-4.694548l-1.043233,0l0,4.694548l1.043233,0zm6.259398,0l1.043233,0l0,-4.694548l-1.043233,0l0,4.694548zm5.216165,0l1.043233,0l0,-4.694548l-1.043233,0l0,4.694548zm2.086466,0l1.043233,0l0,-4.694548l-1.043233,0l0,4.694548zm3.129699,0l0,-4.694548l-1.043233,0l0,4.694548l1.043233,0zm-15.648494,0l2.086466,0l0,-4.694548l-2.086466,0l0,4.694548zm7.302631,0l2.086466,0l0,-4.694548l-2.086466,0l0,4.694548z" clip-rule="evenodd" fill-rule="evenodd" />
            </SvgIcon>} onClick={() =>
            {
              Tone.context.resume().then(() =>
              {
                prevBarcode = "";
                setDialogOpen(true);
                Tone.context.resume();
              });
            }} />
          </BottomNavigation>
        </Container>
      </AppBar>
    </Box>
  );
}
